import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";

import cx from "classnames";
import _, { set } from "lodash";

import {
  deletePersonalization,
  fetchPersonalizationLead,
} from "actions/personalization";

import {
  Button,
  Modal,
  Image,
  Dropdown,

} from "react-bootstrap";
import InfiniteScroll from "components/InfiniteScroll";

import { LoadingMessage } from "pages/storyboards/storyboardSettings/leadReports/components";
import { LeadCreation, LeadDetailView, LeadSelection } from "../modals";

import styles from "./leadList.module.scss";
import TruncatedTextWithTooltip from "components/TruncatedTextWithTooltip";
import CsvUpload from "../csvUpload";

export const LeadsList = React.memo(
  ({ storyboard, handleActiveLead, activeLead }) => {
    const dispatch = useDispatch();

    const [show, setShow] = useState(null);
    const [leadDetails, setLeadDetails] = useState(null);

    const loading = useSelector((state) =>
      _.get(state, `personalization.leads.loading`, false)
    );
    const creating = useSelector((state) =>
      _.get(state, `personalization.leads.creating`, false)
    );
    const pagination = useSelector((state) =>
      _.get(state, "personalization.leads.pagination", {})
    );
    const hasMoreItems =
      _.get(pagination, "currentPage") < _.get(pagination, "totalPages") - 1;
    const leads =
      useSelector((state) => _.get(state, "personalization.leads.items", [])) ||
      [];

    const [selectedFilters, setSelectedFilters] = useState({
      sortType: "modified_date",
      sortOrder: "DESC",
    });

    const filterTypeOption = [
      {
        label: "Name",
        value: "name",
      },
      {
        label: "Date",
        value: "modified_date",
      },
    ];

    const onFilterChange = (type, value) => {
      setSelectedFilters((state) => {
        return {
          ...state,
          [type]: value,
        };
      });
    };


  useEffect(() => {
    handleFetchLeads(0);
    handleActiveLead(null)
  }, [selectedFilters])

  const handleFetchLeads = (page) => {
    const request = {
      storyboard: storyboard,
      sort: selectedFilters.sortType,
      order: selectedFilters.sortOrder,
    };

    dispatch(fetchPersonalizationLead(request, page, 10));
  }


    const handleDetailView = (lead) => {
      setLeadDetails(lead);
    };

    useEffect(() => {
      if(!activeLead){
        handleActiveLead(leads[0]);
      }
    }, [leads]);

    const loadMore = () => {
      const nextPage = pagination.currentPage + 1;
      if (nextPage >= pagination.totalPages) {
        return;
      }
      handleFetchLeads(nextPage);
    };

    const activeDropdownLabel = _.find(filterTypeOption, (data) => {
      return data.value == selectedFilters.sortType;
    });

    return (
      <div className={styles.leadsListContainer}>
        <div className={styles.leadsHeader}>
          <div className={styles.syncContainer}>
            <span className={styles.listTitle}>List of Leads</span>
            <Dropdown autoClose="outside" className={styles.addLeadsButton}>
              <Dropdown.Toggle disabled={creating} variant="success">
                <i className={cx(styles.icon, "cleverstory-plus")} />
                Add Leads
              </Dropdown.Toggle>
              <Dropdown.Menu
                className={`${styles.customDropdownMenu} dropdown-menu-end`}
              >
            <Dropdown.Item onClick={() => setShow("create")} data-track-event="Mixpanel" data-track-props="Add Leads" data-track-source="create">
              <i className={cx(styles.icon, "cleverstory-plus")} />
              Create a Recipient
            </Dropdown.Item>
            <Dropdown.Item onClick={() => setShow("select")} data-track-event="Mixpanel" data-track-props="Add Leads" data-track-source="select">              
              <i className={cx(styles.icon, "cleverstory-user1")} />
              Select Leads
            </Dropdown.Item>
            <Dropdown.Item onClick={() => setShow("csv")}>
              <i className={cx(styles.icon, "cleverstory-table")} />
              Upload CSV
            </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </div>
        </div>
        <div className={styles.sortActionContainer}>
          <div className={styles.conditions}>
            <div className={styles.label}>
              <label className={styles.filterLabel}>Sort by:</label>
              <label className={styles.filterLabel}>
                {selectedFilters.sortOrder && (
                  <img
                    onClick={() =>
                      onFilterChange(
                        "sortOrder",
                        selectedFilters.sortOrder === "ASC" ? "DESC" : "ASC"
                      )
                    }
                    className={cx(
                      styles.sortIcon,
                      selectedFilters.sortOrder === "ASC"
                        ? styles.ascending
                        : styles.descending
                    )}
                    alt="sortIcon"
                    src="/images/sortIcon.svg"
                    data-track-event="Mixpanel" data-track-props="Sort List of Leads" 
                    data-track-order={selectedFilters.sortOrder === "ASC" ? "DESC" : "ASC"} data-track-type={activeDropdownLabel.label}
                  />
                )}
              </label>
            </div>

            <Dropdown className={styles.sortDropdown}>
              <Dropdown.Toggle className={styles.selected}>
                <Button size="sm" variant="primary" className={styles.button}>
                  <span className={styles.filterType}>
                    {activeDropdownLabel.label}
                  </span>
                  <i className={cx(styles.icon, "cleverstory-drop-down")} />
                </Button>
              </Dropdown.Toggle>
              <Dropdown.Menu className={styles.typesMenu}>
                {filterTypeOption.map((option, index) => {
                  return (
                    <Dropdown.Item
                      active={option.value == selectedFilters.sortType}
                      onClick={() => onFilterChange("sortType", option.value)}
                      key={index}
                      eventKey={index}
                    >
                      {option.label}
                    </Dropdown.Item>
                  );
                })}
              </Dropdown.Menu>
            </Dropdown>
          </div>
        </div>
        {loading && leads && leads.length === 0 && (
          <div className={cx(styles.loader, styles.modalLoader)}>
            <LoadingMessage className={styles.loadingMessage} />
          </div>
        )}
        {leads && leads.length > 0 && (
          <InfiniteScroll
            className={styles.leadsList}
            loading={loading}
            hasMore={hasMoreItems}
            loadMore={loadMore}
          >
            {leads.map((lead, index) => {
              return (
                <LeadListRender
                  key={index}
                  activeLead={activeLead}
                  handleActiveLead={handleActiveLead}
                  lead={lead}
                  handleDetailView={handleDetailView}
                />
              );
            })}
          </InfiniteScroll>
        )}
        {leadDetails && (
          <LeadDetailView
            show={leadDetails}
            leadData={leadDetails}
            onClose={() => {
              setLeadDetails(null);
            }}
          />
        )}
        <LeadCreation
          show={show === "create"}
          handleFetchLeads={handleFetchLeads}
          onClose={() => {
            setShow(null);
          }}
        />
        <LeadSelection
          show={show === "select"}
          handleFetchLeads={handleFetchLeads}
          onClose={() => {
            setShow(null);
          }}
        />
        {show === "csv" &&
          <CsvUpload
            onClose={() => {
              setShow(null);
            }}
            handleFetchLeads={handleFetchLeads}
          />
        }
      </div>
    );
  }
);

const LeadListRender = React.memo(
  ({ lead, key, handleDetailView, handleActiveLead, activeLead }) => {
    const dispatch = useDispatch();

    const leadContact = _.get(lead, "contact", {});
    const activeContact = _.get(activeLead, "contact");

    const [deleteModal, showDeleteModal] = useState(false);

    const renderInitials = (name) => {
      let firstName = _.get(name, "firstName") || "-";
      let lastName = _.get(name, "lastName") || "";

      let initial = "";

      if (name) {
        initial = firstName.charAt(0);
      }

      if (lastName) {
        initial = initial + lastName.charAt(0);
      }

      return initial.toUpperCase();
    };

    const handleDelete = () => {
      if (lead) {
        dispatch(deletePersonalization(lead.id));
      }
    };

    return (
      <div
        key={key}
        onClick={() => {
          handleActiveLead(lead);
        }}
        className={cx(styles.leadContainer, {
          [styles.active]: _.isEqual(activeContact, leadContact),
        })}
      >
        <div className={styles.details}>
          <div className={styles.leadInitials}>
            {renderInitials(leadContact)}
          </div>
          <div className={styles.data}>
            <span className={styles.name}>
            <TruncatedTextWithTooltip content={`${leadContact.firstName} ${leadContact.lastName}`} maxWidth={300} placement='top'/>
            </span>
            <span className={styles.mail}>
            <TruncatedTextWithTooltip content={leadContact.email} maxWidth={300} placement='top'/>
            </span>
          </div>
        </div>
        <div className={cx(styles.actions,{[styles.showActions]:_.isEqual(activeContact, leadContact) })}>
          <Button
            onClick={() => {
              handleDetailView(leadContact);
            }}
            variant="info"
            className={styles.viewAction}
          >
            <i className={cx("cleverstory-url")} />
          </Button>
          <Button
            onClick={() => {
              showDeleteModal(true);
            }}
            variant="info"
            className={styles.viewAction}
          >
            <i className={cx("cleverstory-trash", styles.iconMore)} />
          </Button>
        </div>
        <DeleteLeadModal
          deleteModal={deleteModal}
          showDeleteModal={showDeleteModal}
          onDelete={handleDelete}
        />
      </div>
    );
  }
);

export const DeleteLeadModal = ({ deleteModal, showDeleteModal, onDelete }) => {
  const deleting = useSelector((state) =>
    _.get(state, "personalization.leads.deleting", false)
  );
  const deleted = useSelector((state) =>
    _.get(state, "personalization.leads.deleted", false)
  );

  const handleDeleteClick = (e) => {
    onDelete();
    e.stopPropagation();
  };

  useEffect(() => {
    if (deleted) {
      showDeleteModal(false);
    }
  }, [deleted]);

  return (
    <Modal
      className={styles.deletePageModal}
      contentClassName={styles.deletePageModalContent}
      dialogClassName={styles.deletePageModalDialog}
      backdropClassName={styles.backdropWrapper}
      show={deleteModal}
      centered
      size="lg"
      onClick={(e) => {
        e.stopPropagation();
      }}
    >
      <Modal.Body className={styles.deletePageModalBody}>
        <div className={styles.detailsContainer}>
          <div className={styles.messageContainer}>
            <h2 className={styles.messageTitle}>Are you sure?</h2>
            <p className={styles.messageContent}>
              This action of yours will make all the current URL inactive with a
              404 page.
            </p>
            <footer className={styles.deletePageModalButtons}>
              <Button
                variant="secondary"
                onClick={() => {
                  showDeleteModal(false);
                }}
              >
                Cancel
              </Button>
              <Button variant="primary" onClick={handleDeleteClick}>
                {deleting ? "Deleting..." : "Delete"}
              </Button>
            </footer>
          </div>
          <div>
            <Image
              src={"/images/deletePage.png"}
              className={styles.deletePageModalImage}
            />
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};
